import { render, staticRenderFns } from "./ModalPresets.vue?vue&type=template&id=6f8e6ade&scoped=true&"
import script from "./ModalPresets.vue?vue&type=script&lang=js&"
export * from "./ModalPresets.vue?vue&type=script&lang=js&"
import style0 from "./ModalPresets.vue?vue&type=style&index=0&id=6f8e6ade&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8e6ade",
  null
  
)

export default component.exports